import { render, staticRenderFns } from "./SelectShopper.vue?vue&type=template&id=2c040d41&scoped=true&"
import script from "./SelectShopper.vue?vue&type=script&lang=js&"
export * from "./SelectShopper.vue?vue&type=script&lang=js&"
import style0 from "./SelectShopper.vue?vue&type=style&index=0&id=2c040d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c040d41",
  null
  
)

export default component.exports